import { useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import "./Footer.css"

export default function Footer() {
  const theme = useTheme();
  return (
    <footer
      style={{
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.secondary.main,
      }}
    >
      <div id="footer-flex">
        <div id="copyright">
          &copy; 2025 Michelle Laskowski. Alle Rechte vorbehalten.
        </div>
        <div id="legal-links">
          <Link to="/datenschutzerklaerung">Datenschutzerklärung</Link>
          <Link to="/impressum">Impressum</Link>
        </div>
      </div>
    </footer>
  );
}
